module.exports = __webpack_public_path__ + "media/vuesrc/themes/assante/images/auth/email-a938a64ab651adabd2643e400c6a598c.svg";